import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../actions/baseActions";
import { setObj } from "../../../../../actions/noteActions";

const PartialProgressionStatistics = () => (
  <div>ParcialProgressionAllocate</div>
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

PartialProgressionStatistics.defaultProps = {
  hideLayout: false,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartialProgressionStatistics);
